<style scope>
</style>

<template>
  <section class="container">
    <form-pedido-piller/>
  </section>
</template>

<script>
  import FormPedidoPiller from './piller/FormPedidoPiller'

  export default {
    components: {FormPedidoPiller},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/pedido/Form.vue